import removeAccents from 'remove-accents';
import UrlSaveString from 'url-safe-string';

const descriptionDefault = 'image';
var getResizedImage = ({ cropType = 'fit-in', size = '200x200', url, description = descriptionDefault }) => {
  let result = (url || '').replace('{action}', cropType).replace('{width}x{height}', size);
  if (description !== descriptionDefault) {
    const tagGenerator = new UrlSaveString();
    let urlDescription = removeAccents(description);
    urlDescription = tagGenerator.generate(urlDescription);
    return result.replace('{description}', urlDescription);
  }
  return result;
};

export { getResizedImage as default };
//# sourceMappingURL=get-resized-image.js.map
